import * as React from "react"
export const Svg_031 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M14.98 51.235h29.04v3.457H14.98v-3.457Z" />
    <path fill="url(#b)" d="M17.285 14.679h24.43v15.814h-24.43V14.679Z" />
    <path fill="url(#c)" d="M14.98 44.321h29.04v3.457H14.98v-3.457Z" />
    <path
      fill="url(#d)"
      d="M59 4.308H0v43.47h11.523v-3.457H9.22v-3.457H49.78v3.457h-2.304v3.457H59V4.308ZM8.643 31.228H5.186v-3.457h3.457v3.457Zm0-6.914H5.186v-3.457h3.457v3.457Zm0-6.914H5.186v-3.457h3.457V17.4Zm36.529 16.55H13.828V11.222h31.344V33.95Zm8.643-2.722h-3.458v-3.457h3.458v3.457Zm0-6.914h-3.458v-3.457h3.458v3.457Zm0-6.914h-3.458v-3.457h3.458V17.4Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={21.696}
        x2={21.964}
        y1={51.754}
        y2={55.406}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={22.934}
        x2={28.727}
        y1={17.051}
        y2={31.533}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={21.696}
        x2={21.964}
        y1={44.84}
        y2={48.492}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.644}
        x2={31.057}
        y1={10.828}
        y2={49.077}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)